import { render, staticRenderFns } from "./CardGaleriesTwo.vue?vue&type=template&id=0a6971d3&scoped=true&"
import script from "./CardGaleriesTwo.vue?vue&type=script&lang=js&"
export * from "./CardGaleriesTwo.vue?vue&type=script&lang=js&"
import style0 from "./CardGaleriesTwo.vue?vue&type=style&index=0&id=0a6971d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6971d3",
  null
  
)

export default component.exports